import {seasonTypes, systemTypes} from '../helpers/constants';


export function validateTemperatureCelsius(temperature, poolType, season) {
  let valid = (!!temperature || temperature === 0) && parseInt(temperature).toString() === temperature.toString();

  if (poolType === systemTypes.spa) {
    valid = valid && temperature >= 26 && temperature <= 40;
    return valid;
  }

  if (poolType === systemTypes.swimspa) {
    valid = valid && temperature >= 21 && temperature <= 37;
    return valid;
  }

  if (season === seasonTypes.inSeason) {
    valid = valid && temperature >= 21 && temperature <= 37;
  } else if (season === seasonTypes.opening) {
    valid = valid && temperature >= 21 && temperature <= 37;
  }
  return valid;

}


export function validateTemperatureFarenheit(temperature, poolType, season) {
  let valid = (!!temperature || temperature === 0) && parseInt(temperature).toString() === temperature.toString();

  if (poolType === systemTypes.pool) {

    if (season === seasonTypes.inSeason) {
      valid = valid && temperature >= 70 && temperature <= 99;
    } else if (season === seasonTypes.opening) {
      valid = valid && temperature >= 70 && temperature <= 99;
    }
    return valid;
  }

  return valid && temperature >= 70 && temperature <= 104;
}
